document.addEventListener('DOMContentLoaded', () => {  
  const contactSlider = document.querySelector('.platkiBanner');
  
  if (contactSlider) {
      const splide = new Splide(contactSlider, {
          arrows: false,
          type: 'loop',
          clones: 5,
          autoWidth: true,
          autoScroll: {
            speed: 0.8,
          },
          pagination: false,
          gap: '36px',
          perPage: 1,
          perMove: 1,
          mediaQuery: 'min',
          breakpoints: {
                  1500: {
                  destroy: true,
                          },
                  400: {
                  gap: '36px',
                          },
                  300: {
                  gap: '24px',
                          },
                       }
      });
  
      splide.mount(window.splide.Extensions);
  }

});